/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { IRemoteDto } from "./i-remote-dto";
import { UserAcdOccupiedByUserInfoRemoteDto } from "./user-acd-occupied-by-user-info-remote-dto";

export class UserAcdExtensionInfoRemoteDto implements IRemoteDto {
    opextId: number;
    name: string;
    isAvailable: boolean;
    acdNumber: string;
    acdLine: string;
    defaultSkillId: number;
    ringtoneUsageDisabled: boolean;
    userAcdOccupiedByUserInfo: UserAcdOccupiedByUserInfoRemoteDto;
}
